import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    user: localStorage.getItem('adminUser') ? JSON.parse(localStorage.getItem('adminUser')) : null,
    token: localStorage.getItem('adminToken') || null,
    isAuthenticated: !!localStorage.getItem('adminToken'),
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCredentials: (state, action) => {
            const { user, token } = action.payload;
            state.user = user;
            state.token = token;
            state.isAuthenticated = true;
            localStorage.setItem('adminToken', token);
            localStorage.setItem('adminUser', JSON.stringify(user));
        },
        logout: (state) => {
            state.user = null;
            state.token = null;
            state.isAuthenticated = false;
            localStorage.removeItem('adminToken');
            localStorage.removeItem('adminUser');
        },
    },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
